<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
<style>
  @import "./common/font.css";
  *{
    margin: 0;
    font-family: GE,GE_zh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue